<!-- 由 suu 创建于 2021-09-16 星期四 -->
<template>
  <div class="BMICount">
    <div class="bc-panel">
      <div class="p-title">请输入您的身高、体重</div>
      <van-field
        v-model="height"
        label="身高（cm）"
        type="number"
        placeholder="请输入您的身高"
      />
      <van-field
        v-model="weight"
        label="体重（kg）"
        type="number"
        placeholder="请输入您的体重"
      />
      <!-- <div class="p-btn user-btn">计算</div> -->
      <template v-if="num">
        <div class="p-text we-line-title">您的BMI指数为</div>
        <div class="p-num">{{ num }}</div>
        <div
          class="p-label"
          v-if="curLabel"
          :style="{ backgroundColor: curLabel.color }"
        >
          {{ curLabel.title }}
        </div>
      </template>
    </div>
    <div class="bc-panel">
      <div class="p-title">成年人身体质量指数（BMI）</div>
      <div class="p-desc">
        是目前国际相对可靠常用的一种衡量人体胖瘦程度以及健康状况的指标。适用于我国成年人。<br />
        不适用人群：未成年人、运动员、孕妇、老人等<br />
        计算公式：体质指数（BMI）= 体重（kg）÷ 身高（m）²
      </div>
      <div class="p-card">
        <div class="card-title">BMI正常值范围</div>
        <div class="card-line"></div>
        <div class="card-list">
          <div class="l-item" v-for="(item, index) in labels" :key="index">
            <div class="i-title" :style="{ color: item.color }">
              {{ item.title }}
            </div>
            <div class="i-range">
              {{
                `${item.min != -Infinity ? item.min + '<' : ''}BMI${
                  item.max != Infinity ? '≤' + item.max : ''
                }`
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="p-tips">
        *资料来源：《中国居民膳食指南》（2022）-p29--中国营养学会编著
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BMICount',

  components: {},

  props: {},

  data() {
    return {
      labels: [
        {
          min: -Infinity,
          max: 18.5,
          title: '偏瘦',
          color: '#2882e9'
        },
        {
          min: 18.5,
          max: 24,
          title: '健康',
          color: '#35c763'
        },
        {
          min: 24,
          max: 28,
          title: '偏重',
          color: '#f7b500'
        },
        {
          min: 28,
          max: Infinity,
          title: '肥胖',
          color: '#f04646'
        }
      ],
      height: null,
      weight: null
    }
  },

  computed: {
    num() {
      if (this.weight && this.height) {
        return (
          this.weight /
          (((this.height / 100) * this.height) / 100)
        ).toFixed(1)
      }
      return null
    },
    curLabel() {
      if (this.num) {
        for (let index = 0; index < this.labels.length; index++) {
          const ele = this.labels[index]
          if (this.num > ele.min && this.num <= ele.max) {
            return ele
          }
        }
      }
      return null
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.BMICount {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  position: relative;
  color: #000;
  .bc-panel {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: solid 2.7vw #f9f9f9;
    padding: 6.4vw 5.3vw;
    .p-title {
      width: 100%;
      box-sizing: border-box;
      font-size: 4vw;
      font-weight: 600;
      margin-bottom: 1.3vw;
    }
    ::v-deep {
      .van-cell {
        width: 89.3vw;
        height: 9.6vw;
        background-color: #f7f7f7;
        border-radius: 2.7vw;
        border: solid 0.3vw #f1f1f1;
        box-sizing: border-box;
        padding: 2.1vw 5.3vw;
        margin-top: 2.7vw;
        font-size: 3.7vw;
        color: #000;
        line-height: normal;
        .van-field__label {
          color: #000;
        }
        .van-field__control {
          color: #000;
          font-weight: 600;
        }
      }
    }
    .p-text {
      margin-top: 6.7vw;
      font-size: 4vw;
      color: rgba(0, 0, 0, 0.5);
    }
    .p-num {
      font-size: 10.7vw;
      font-weight: 600;
      margin-top: 1.9vw;
    }
    .p-label {
      width: 22.7vw;
      height: 5.9vw;
      border-radius: 1.1vw;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 4vw;
      font-weight: 600;
      margin-top: 2.1vw;
    }

    .p-desc {
      font-size: 3.5vw;
      line-height: 6.9vw;
      color: rgba(0, 0, 0, 0.5);
    }
    .p-card {
      width: 89.3vw;
      height: 26.4vw;
      background-color: #ffffff;
      border-radius: 1.1vw;
      border: solid 0.3vw #e7e7e7;
      margin-top: 6.7vw;
      box-sizing: border-box;
      padding: 3.2vw 3.5vw;
      .card-title {
        font-size: 3.5vw;
        font-weight: 600;
      }
      .card-line {
        width: 84.3vw;
        border-top: 0.3vw solid #f7f7f7;
        margin: 2.1vw auto;
      }
      .card-list {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .l-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .i-title {
            font-size: 3.2vw;
            font-weight: 600;
          }
          .i-range {
            font-size: 2.7vw;
            font-weight: 600;
            margin-top: 1.3vw;
          }
        }
      }
    }
    .p-tips {
      font-size: 2.7vw;
      line-height: 6.9vw;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 1.9vw;
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
